import { FC } from "react";
import { FormFieldProps, ValuePropKeys } from "../form-field/FormFieldProps";

export interface DelegatedFormFieldProps<V, T extends FormFieldProps<V>> {
  formFieldComponent: FC<T>;
  additionalFormFieldProps: Omit<T, ValuePropKeys<V>>;
}

export interface SingleInputProps<V, T extends FormFieldProps<V>> extends DelegatedFormFieldProps<V, T> {
  formFieldProps: Pick<T, keyof FormFieldProps<V>>;
}

export const SingleInput = <V, T extends FormFieldProps<V>>(props: SingleInputProps<V, T>) => {
  const { formFieldComponent: FormFieldComponent, additionalFormFieldProps, formFieldProps } = props;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const formFieldComponentProps: T = {
    ...additionalFormFieldProps,
    ...formFieldProps,
  };

  return (
    <FormFieldComponent {...formFieldComponentProps}/>
  );
};
